import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const TemplateDocuments = ({ templateDocumentList }) => {

    const templateDocColumns = [
      {
        field: "documentId",
        headerName: "Document ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "fileName",
        headerName: "File Name",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "newgenId",
        headerName: "Newgen ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "typeId",
        headerName: "Type ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "type",
        headerName: "Type",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "modifiedBy",
        headerName: "Modified By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.createdDate),
      },
      {
        field: "modifiedDate",
        headerName: "Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.modifiedDate),
      },
    ];

        return(
            <AccordianContainer
            id="accord"
            title="Template Documents"
            initialOpen={false}
          >
            <Box sx={{ marginTop: "-0.5%" }}>
            <CustomDataGrid
              noDataMessage="No Data"
              rows={ validate(templateDocumentList) ?
                templateDocumentList.map((item, index) => ({
                  id: index + 1,
                  ...item,
                })) : []}
              columns={templateDocColumns}
              pageSize={15}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              gridHeight={305}
              getRowId={(row) => row.documentId}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
            />
            </Box>
            </AccordianContainer>
        );

}

export default TemplateDocuments;